export interface ChargeDto {
  chargeTypeId: number
  description: string
  amount: number
  amountPerVIN?: number
  additionalVINs?: string[]
}

export const chargeInit: ChargeDto = {
  chargeTypeId: 0,
  description: '',
  amount: 0,
  amountPerVIN: undefined,
  additionalVINs: []
}
